import { Appear, Flex, Grid, GridProps, SkeletonBox, variables } from '@bitrise/bitkit';
import { TypeAttribute } from '@trace/types';
import React, { FunctionComponent, ReactNode } from 'react';
import AttributeStat from './AttributeStat';

interface Props extends GridProps {
  attributes: {
    attribute: TypeAttribute | string;
    children?: ReactNode;
    title?: string;
    value?: number | string;
  }[];
  attributesPerRow?: number;
  showLoadingIndicator?: boolean;
  withIcon?: boolean;
}

const AttributeStatGrid: FunctionComponent<Props> = ({
  attributes,
  attributesPerRow,
  showLoadingIndicator,
  withIcon,
  ...rest
}) => {
  return (
    <Grid {...rest} gapHorizontal="x8" gapVertical="x4" repeat={attributesPerRow} repeatWidth="1fr">
      {attributes.map(({ attribute, children, title, value }, index) => (
        <Appear
          Component={Flex}
          animation="FadeSlideDown"
          delay={(variables.transitionDurationFast / 3) * index}
          direction="vertical"
          duration="fast"
          gap="x4"
          key={`${attribute}-${title}`}
        >
          <AttributeStat attribute={attribute} grow title={title} value={value} withIcon={withIcon}>
            {showLoadingIndicator ? <SkeletonBox height="1.125rem" /> : children}
          </AttributeStat>
        </Appear>
      ))}
    </Grid>
  );
};

export default AttributeStatGrid;
